import { inject } from "vue";
import { storeKey } from "./vars";
const useAnalyticManager = () => {
    const AnalyticManager = inject(storeKey);
    if (!AnalyticManager) {
        console.warn("Плагин AnalyticManagerPlugin не подключён");
    }
    return {
        config: (config) => {
            if (AnalyticManager) {
                AnalyticManager.config(config);
            }
        },
        events: (events) => {
            if (AnalyticManager) {
                AnalyticManager.events(events);
            }
        },
        globalParams: (values) => {
            if (AnalyticManager) {
                AnalyticManager.globalParams(values);
            }
        },
        send: (name, params) => {
            if (AnalyticManager) {
                AnalyticManager.send(name, params);
            }
        },
    };
};
export default useAnalyticManager;
